<nav id="admin-menu-inc" *ngIf="contactType == 'SuperAdmin'">
    <div class="" id="admin-menu">
        <div class="logo">
            <a href="https://indychamber.com/" class="border-0" target="_blank"><img src="../assets/images/logo/logo-white.svg"
                    alt="Indy Chamber Logo" /></a>
        </div>
        <ul class="list-unstyled site-nav accordion accordion-flush" id="accordionMenu">

            <li class="accordion-item">
                <button type="button" data-bs-toggle="collapse" data-bs-target="#usersMenu"
                        data-bs-parent="#accordionMenu" aria-expanded="true" aria-controls="usersMenu"
                        class="accordion-button">
                    <span class="menuIcon">
                        <i class="fa-regular fa-users"></i>
                    </span>Users
                </button>
                <ul class="accordion-collapse collapse show list-unstyled" aria-labelledby="flush-headingOne"
                    id="usersMenu">
                    <li>
                        <a id="super-admins" [routerLink]="['/admin-portal/chamber/super-admin-management']"
                           routerLinkActive="activePage">
                            <span class="menuIcon"><i class="fa-regular fa-user-shield"></i></span>Super-Admins
                        </a>
                    </li>
                    <li>
                        <a id="members" [routerLink]="['/admin-portal/chamber/super-admin-member-management']"
                           routerLinkActive="activePage">
                            <span class="menuIcon"><i class="fa-regular fa-id-card"></i></span>Members
                        </a>
                    </li>
                    <li>
                        <a id="chamber-perks" [routerLink]="['/admin-portal/chamber/chamber-perks-management']"
                           routerLinkActive="activePage">
                            <span class="menuIcon">
                                <i class="fa-regular fa-gift"></i>
                            </span>Chamber Perks
                        </a>
                    </li>
                    <li>
                        <a id="payment-history" [routerLink]="['/admin-portal/chamber/payment-history']"
                            routerLinkActive="activePage"><span class="menuIcon"><i
                                    class="fa-regular fa-dollar"></i></span>Payment History</a>
                    </li>
                </ul>
            </li>
            <li class="accordion-item">
                <button type="button" data-bs-toggle="collapse" data-bs-target="#pendingMenu"
                        data-bs-parent="#accordionMenu" aria-expanded="true" aria-controls="pendingMenu"
                        class="accordion-button">
                    <span class="menuIcon">
                        <i class="fa-duotone fa-spinner"></i>
                    </span>Submissions
                </button>
                <ul class="accordion-collapse collapse list-unstyled" aria-labelledby="flush-headingOne"
                    id="pendingMenu">
                    <li>
                        <a id="pendingApps" [routerLink]="['/admin-portal/chamber/pending-applications']"
                           routerLinkActive="activePage">
                            <span class="menuIcon">
                                <i class="fa-regular fa-ballot"></i>
                            </span>Pending Applications
                        </a>
                        <a id="pendingNews" [routerLink]="['/admin-portal/chamber/pending-news']"
                           routerLinkActive="activePage">
                            <span class="menuIcon">
                                <i class="fa-regular fa-newspaper"></i>
                            </span>News Submissions
                        </a>
                        <a id="pendingLetters" [routerLink]="['/admin-portal/chamber/pending-letters']"
                           routerLinkActive="activePage">
                            <span class="menuIcon">
                                <i class="fa-regular fa-handshake"></i>
                            </span>Pending Letters
                        </a>
                        <a id="pendingDiscounts" [routerLink]="['/admin-portal/chamber/pending-discounts']"
                           routerLinkActive="activePage">
                            <span class="menuIcon">
                                <i class="fa-regular fa-ticket"></i>
                            </span>Discount Submissions
                        </a>
                        <a id="pendingAds" [routerLink]="['/admin-portal/chamber/pending-ads']"
                           routerLinkActive="activePage">
                            <span class="menuIcon">
                                <i class="fa-regular fa-rectangle-ad"></i>
                            </span>Ad Submissions
                        </a>
                    </li>
                </ul>
            </li>
            <!-- <li class="accordion-item">
        <button type="button" data-bs-toggle="collapse" data-bs-target="#contentMenu" data-bs-parent="#accordionMenu"
                aria-expanded="false" aria-controls="contentMenu" class="accordion-button collapsed">
            <span class="menuIcon">
                <i class="fa-regular fa-book"></i>
            </span>Big Menu
        </button>
        <ul class="accordion-collapse collapse list-unstyled" id="contentMenu">
            <li><a href="javascript:void(0);">menu item</a></li>
            <li><a href="javascript:void(0);">menu item</a></li>
            <li><a href="javascript:void(0);">menu item</a></li>
            <li><a href="javascript:void(0);">menu item</a></li>
            <li><a href="javascript:void(0);">menu item</a></li>
        </ul>
    </li> -->
            <li>
                <a id="resources" [routerLink]="['/admin-portal/chamber/super-admin-resources']"
                   routerLinkActive="activePage">
                    <span class="menuIcon"><i class="fa-light fa-book"></i></span>Resources
                </a>
            </li>
            <li>
                <a id="settings" [routerLink]="['/admin-portal/chamber/super-admin-settings']"
                   routerLinkActive="activePage">
                    <span class="menuIcon"><i class="fa-light fa-cog"></i></span>Settings
                </a>
            </li>
            <li>
                <a id="#" [routerLink]="['/public/member-directory']" routerLinkActive="activePage"><span
                        class="menuIcon"><i class="fa-regular fa-person-to-portal"></i></span>Member Directory</a>
            </li>
        </ul>

    </div>
</nav>
<nav id="admin-menu-inc" *ngIf="contactType == 'BusinessUser'">
    <div class="" id="admin-menu">
        <div class="logo">
            <a class="border-0"><img src="../assets/images/logo/logo-white.svg"
                    alt="Indy Chamber Logo" /></a>
        </div>
        <ul class="list-unstyled site-nav accordion accordion-flush" id="accordionMenu">
            <li *ngIf="membershipLevel != 'HealthAlliance'">
                <a id="dashboard" [routerLink]="['/admin-portal/member/dashboard']" routerLinkActive="activePage">
                    <span class="menuIcon"><i class="fa-regular fa-tachometer"></i></span>My Dashboard
                </a>
            </li>
            <li>
                <a id="my-info" [routerLink]="['/admin-portal/member/membership-management']"
                   routerLinkActive="activePage">
                    <span class="menuIcon"><i class="fa-regular fa-id-card"></i></span>My Business Listing
                </a>
            </li>
            <li class="accordion-item">
                <button type="button" data-bs-toggle="collapse" data-bs-target="#usersMenu"
                        data-bs-parent="#accordionMenu" aria-expanded="true" aria-controls="usersMenu"
                        class="accordion-button">
                    <span class="menuIcon">
                        <i class="fa-regular fa-users"></i>
                    </span>Users
                </button>
                <ul class="accordion-collapse collapse show list-unstyled" aria-labelledby="flush-headingOne"
                    id="usersMenu">
                    <li>
                        <a id="members" [routerLink]="['/admin-portal/member/user-management']"
                           routerLinkActive="activePage">
                            <span class="menuIcon">
                                <i class="fa-regular fa-user"></i>
                            </span>My Members
                        </a>
                    </li>
                    <li>
                        <a id="invoices" [routerLink]="['/admin-portal/member/invoice-management']"
                           routerLinkActive="activePage">
                            <span class="menuIcon">
                                <i class="fa-regular fa-file-invoice"></i>
                            </span>Invoices
                            <!-- <span class="ms-2 badge text-bg-overdue badgeOverdue">1</span> -->
                        </a>
                    </li>
                </ul>
            </li>
            <li class="accordion-item" *ngIf="membershipLevel != 'HealthAlliance'">
                <button type="button" data-bs-toggle="collapse" data-bs-target="#engageMenu"
                        data-bs-parent="#accordionMenu" aria-expanded="true" aria-controls="engageMenu"
                        class="accordion-button">
                    <span class="menuIcon">
                        <i class="fa-regular fa-users"></i>
                    </span>Engage
                </button>
                <ul class="accordion-collapse collapse show list-unstyled" aria-labelledby="flush-headingOne"
                    id="engageMenu">
                    <li>
                        <a id="members" [routerLink]="['/admin-portal/member/submit-member-news']"
                           routerLinkActive="activePage">
                            <span class="menuIcon"><i class="fa-regular fa-user"></i></span>Submit News
                        </a>
                    </li>
                    <li *ngIf="canViewAds">
                        <a id="members" [routerLink]="['/admin-portal/member/member-ads']"
                           routerLinkActive="activePage">
                            <span class="menuIcon"><i class="fa-regular fa-rectangle-ad"></i></span>Ads
                        </a>
                    </li>
                    <li>
                        <a id="members" [routerLink]="['/admin-portal/member/submit-member-discount']"
                           routerLinkActive="activePage">
                            <span class="menuIcon"><i class="fa-regular fa-ticket"></i></span>Submit Discount
                        </a>
                    </li>
                </ul>
            </li>
            <li>
                <a id="#" [routerLink]="['/public/member-directory']" routerLinkActive="activePage">
                    <span class="menuIcon"><i class="fa-regular fa-person-to-portal"></i></span>Member Directory
                </a>
            </li>
            <li>
                <a id="counterpartLink" class="counterpartLink" href="https://www.counterpart.biz/" target="_blank"><img src="../assets/images/logo/counterpart-blue.png" alt="Counterpart logo" /><span class="float-end"><i class="fa-regular fa-arrow-up-right-from-square"></i></span></a>
            </li>

        </ul>
    </div>
</nav>